export const paths = {
  home: '/',
  category: '/',
  product: '/product/',
  cart: '/cart',
  wishlist: '/wishlist',
  checkout: '/checkout',
  guestLogin: '/guest/login',
  readonlyCheckout: '/readonly-checkout',
  search: '/search',
  account: '/my-account/personal-data',
  confirmation: '/confirmation',
  accountPersonalData: '/my-account/personal-data',
  accountBillingDetails: '/my-account/billing-details',
  accountShippingDetails: '/my-account/shipping-details',
  accountMyOrders: '/my-account/my-orders',
  accountMyWishlist: '/my-account/wishlist',
  accountReturns: '/my-account/returns',
  accountNewReturn: '/my-account/new-return',
  authResetPassword: '/reset-password',
  authResetPasswordSuccess: '/reset-password-success',
  authLogin: '/login',
  termsAndConditions: '/terms-and-conditions',
  cancellationRights: '/cancellation-rights',
  legalDisclosure: '/legal-disclosure',
  privacyPolicy: '/privacy-policy',
  shipping: '/shipping',
  cancellationForm: '/cancellation-form',
  declarationOfAccessibility: '/declaration-of-accessibility',
  contact: '/contact',
  register: '/register',
  globalItemCategory: '/editor-layout-item-category',
  globalItemDetails: '/editor-layout-item-details_0',
};
